import { add, format, isBefore, isSameDay } from 'date-fns';
import { fr } from 'date-fns/locale';
/**
 * Formatte une date sous la forme "22/05/2000"
 *
 * @param date : Date d'entrée a formatter
 */
export const formatDateCourt = (date: string | Date): string => {
  if (typeof date === 'object') {
    return format(date, 'dd/MM/yyyy', { locale: fr });
  } else {
    const dateFormat = new Date(date);
    return format(dateFormat, 'dd/MM/yyyy', { locale: fr });
  }
};

export const dateLowerOtherSameDate = (date: any) => {
  return isBefore(new Date(date), new Date()) || isSameDay(new Date(date), new Date());
};

export const datePlusOneDay = (date: string) => {
  const datePlusOne = add(new Date(date), { days: 1 });

  return formatDateCourt(datePlusOne);
};

export const buildBlob = (content, type, title?) => {
  const byteCharacters = atob(content);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const file = new Blob([byteArray], { type: type });
  const fileURL = URL.createObjectURL(file);
  window.open(fileURL);
};

export const ibanFormat = () => {
  return /^([A-Z]{2}[ -]?[0-9]{2})(?=(?:[ -]?[A-Z0-9]){9,30}$)((?:[ -]?[A-Z0-9]{3,5}){2,7})([ -]?[A-Z0-9]{1,3})?$/;
};
export const bicFormat = () => {
  return /^[A-Za-z]{6}[0-9A-Za-z]{2}([0-9A-Za-z]{3})?$/;
};

export const buildTarif = (tarif: number | string) => {
  return tarif.toString().replace('.', ',') + '€';
};
